<template>
    <div>
        <table v-if="!loading && orders.length">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Cliente</th>
                    <th>Status</th>
                    <th>Itens</th>
                    <th>Total</th>
                    <th>Criado em</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(ord, index) in orders" :key="index">
                    <td>{{ index+1 }}</td>
                    <td><template v-if="ord.company">{{ ord.company.companyname }}</template></td>
                    <td>
                        <template v-if="ord.status">
                            <span class="badge yellow" v-if="ord.status.id == 1">Aguardando cotação</span>
                            <span class="badge blue" v-if="ord.status.id == 2">Aguardando confirmação</span>
                            <span class="badge green" v-if="ord.status.id == 3">Aguardando pagamento</span>
                            <span class="badge blue" v-if="ord.status.id == 4">Pedido em produção</span>
                            <span class="badge green" v-if="ord.status.id == 5">Pedido em transporte</span>
                            <span class="badge green" v-if="ord.status.id == 6">Pedido em concluído</span>
                        </template>
                    </td>
                    <td>{{ ord.items.length }}</td>
                    <td>-</td>
                    <td>{{ $moment(ord.createdOn,'X').format('DD/MM/YYYY HH:mm') }}</td>
                    <td><button @click="openForm(index)"><i class="mdi mdi-pencil"></i></button></td>
                </tr>
            </tbody>
        </table> 
        <p v-if="loading">Carregando...</p>
        <p v-if="!loading && !orders.length"><strong>Nenhum registro</strong></p>
        <modal :show="edit" v-model="edit">
            <div slot="body">
                <!-- <order :order="order" v-if="edit"></order> -->
            </div>
        </modal>

    </div>
</template>
<script>
import Modal from '../../components/Modal'
export default {
    name: 'ordersList',
    components: {
        // order,
        Modal
    },
    data(){
        return{
            loading: false,
            orders: [],
            order: {},
            edit: false
        }
    },
    
    firestore() {
        this.loading = true
        return {
            ordersTg: this.$db.collection("orders").get()
            .then((snap) => {
                let order = []
                this.loading = true
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    order.push(data)
                });

                this.orders = order
                this.loading = false
            })
        }
    },
    methods: {
        openForm(index){
            this.order = this.orders[index]
            this.edit = true
        }
    }
}
</script>  